export default "__VITE_ASSET__362d3093__"